import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  margin: 0;
  margin-top: 20px;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  & > button {
    flex: unset;
    font-size: 18px;
    padding: 0;
    margin: 0;
    height: 55px;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    display: grid;
    grid-template-columns: 229px 229px;
    grid-auto-rows: 79px;
    justify-content: center;
    gap: 40px;

    & > button {
      font-size: 24px;
      height: 100%;
    }
  }
`;
